<template>
    <div class="wizard__wrap">
        <div class="wizard__block wizard__block">
            <div class="row">
                <div class="logo logo--after">
                    {{ agencyName }}
                </div>
            </div>

            <div class="wizard__block-title">
                {{ agencyName }}'s action plan for {{ currentMonth }} is
                complete!
            </div>
            <div class="wizard__block-title">Thank you!</div>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import { scrollToTop } from "../../../helpers/_scrollToTop";

export default {
    name: "Wizard_No_Actions",
    computed: {
        currentMonth: () => {
            return moment().format("MMMM'YY");
        },
        agencyName() {
            return this.$store.getters.getAgencyName;
        },
    },
    mounted() {
        scrollToTop();
    },
    methods: {},
};
</script>
